// Roles approved from the October 2, 2026 Miami TV Commercial Reality review.
// Exact IDs keep confidence/mobile bundles independent of naming and tags.
const approvedRoles = {
  "5f3150cfe52cbd37797ad26a": "bundles",
  "61d5fab9e90223d8d1655466": "displays",
  "6227882f32d37024139b12ca": "displays",
  "62bd813666198c48ebb94093": "bundles",
  "63206af0dadb226466de1889": "accessories",
  "63206bf5dadb226466de18c2": "bundles",
  "63206c89dadb226466de18de": "bundles",
  "6328d68088f8023b7e8d4403": "displays",
  "6328d71788f8023b7e8de571": "bundles",
  "6335f915cc261f495d0f52a0": "bundles",
  "63375f5df0ea9e1e7c92f620": "displays",
  "635187323f0b3c594baeeed7": "displays",
  "64244b7b6f59f42e2da71c9a": "displays",
  "64244d796f59f42e2da71cf4": "bundles",
  "651da043b02d970fae96c157": "bundles",
  "66158912952687021efaf6c9": "accessories",
  "66f3cf73817c71105a518a3d": "displays",
  "66f3d2d7d2ac1a03c88a6d20": "accessories",
  "671f9fe9a9b04ef886ab9c4d": "bundles",
  "6720ddedcfb8311063ae4295": "bundles",
  "672273f1c15cdb105a82adb9": "bundles",
  "673391856dfc5813d5b1a300": "displays",
  "677c3a73f7be7f0898f56a63": "accessories",
  "677c3dc34c75fd105c609c69": "bundles",
  "67cb09a55ab0f7106633982b": "bundles",
  "6811109d15cf7c1074a035df": "bundles",
  "696558be54c347ae068462df": "displays",
  "69655a3254c347ae0684fdef": "bundles",
  "69713ccd0eee25dc5de371ee": "accessories"
}

// This rig has a retained product route and Orlando catalog placement, but was
// explicitly excluded from the approved Miami landing-page offer.
const excludedMiamiProducts = new Set(['61d8398d62920e7f44575f6d'])

export const getMiamiTvCatalogs = (products = []) => {
  const groups = { bundles: [], displays: [], accessories: [], other: [] }
  const seen = new Set()
  products.forEach(product => {
    const id = String(product?._id || '')
    if (!id || seen.has(id) || excludedMiamiProducts.has(id)
      || !product.categories?.includes('Visuals/TVs')) return
    seen.add(id)
    // New products remain reachable. Only explicit bundle/taxonomy evidence
    // promotes an unreviewed SKU to the primary configured-bundle offer.
    const role = approvedRoles[id] || (product.bundle
      || product.categories.some(category => category.startsWith('Bundle/'))
      ? 'bundles' : 'other')
    groups[role].push(product)
  })
  return groups
}
